exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#body{\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n}\n", "", {"version":3,"sources":["/root/.jenkins/workspace/prod-dyw-shop-web-pc/src/page/index/index.vue"],"names":[],"mappings":";AACA;EACE,2BAA2B;EAC3B,6BAA6B;CAC9B","file":"index.vue","sourcesContent":["\n#body{\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b0c87af","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/index/index.vue
// module id = /NXq
// module chunks = 4